module.exports = __webpack_public_path__ + "img/clock-minus.cbff6612.svg";